import { index, integer, pgTable, text, unique } from 'drizzle-orm/pg-core'
import { relations } from 'drizzle-orm'
import {
  getBaseFields,
  getBaseIndexes,
  getNullableIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { newsletters } from './newsletter'
import { users } from './user'

export const shortUrls = pgTable(
  'short_urls',
  {
    ...getBaseFields(),
    key: text().notNull(),
    targetUrl: text().notNull(),
    openedAt: getTimestampWithTimezone(),
    expiresAt: getTimestampWithTimezone(),
    newsletterId: getNullableIdReference(() => newsletters.id),
    userId: getNullableIdReference(() => users.id),
    clickCount: integer().notNull().default(0),
  },
  (table) => [
    ...getBaseIndexes('short_urls', table),
    unique('short_urls_key_unique').on(table.key),
    index('short_urls_newsletter_id_idx').on(table.newsletterId),
    index('short_urls_user_id_idx').on(table.userId),
  ],
)

export const shortUrlsRelations = relations(shortUrls, ({ one }) => ({
  newsletter: one(newsletters, {
    fields: [shortUrls.newsletterId],
    references: [newsletters.id],
  }),
  user: one(users, {
    fields: [shortUrls.userId],
    references: [users.id],
  }),
}))
